import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form/dist/index.ie11";
import * as yup from "yup";

import {
  ContractType,
  useAddNotificationMutation,
  useCreateTemplateRegisterMutation,
  useUploadFileCatalogMutation,
} from "~/schemas/generated/graphql";

import DropZone from "~/components/DropZone";
import Button from "~/shared/ui/Fields/Button";
import Input from "~/shared/ui/Fields/Input";
import Select from "~/shared/ui/Fields/Select";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

import s from "./UploadForm.less";
import { NOTIFICATIONS } from "~/constans/notifications";
import { useGetLocationData } from "~/hooks/locationData";
import { yupResolver } from "@hookform/resolvers/yup";
import clsx from "clsx";

interface IProps {
  setCloseModal: () => void;
  refetch;
}

const UploadHTMLForm: FC<IProps> = ({ setCloseModal, refetch }) => {
  const { t } = useTranslation();

  const [file, setFile] = useState({});
  const [textFile, setTextFile] = useState("");
  const { openModal, event } = useGetLocationData();
  const currentDealerId = useCurrentDealerId();
  const [addNotificationMutation] = useAddNotificationMutation({});
  const optionsType = ["Custom", "Contract"];
  const [uploadFileCatalog, FileUpload] = useCreateTemplateRegisterMutation({
    onCompleted() {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.success,
          content: t("common.file_uploaded_successfully"),
        },
      });
      refetch();
      setCloseModal();
    },
    onError() {
      setCloseModal();
    },
  });

  function readFile(files) {
    let reader = new FileReader();

    reader.readAsText(files);

    reader.onloadend = () => {
      setTextFile(reader.result as string);
    };
  }

  useEffect(() => {
    if (Object.keys(file).length > 0) {
      readFile(file);
    }
  }, [file]);

  const schema = yup.object().shape({
    name: yup
      .string()
      .max(250, t("validation.more250"))
      .required(t("validation.required")),
  });

  const { handleSubmit, control, errors } = useForm({
    defaultValues: {
      type: { label: t("dealers.Contract"), value: "Contract" },
    },
    resolver: yupResolver(schema),
  });

  // const textHtml =  readFile(file)  || ""

  const onSubmit = ({ name, date, type }) => {
    uploadFileCatalog({
      variables: {
        html: textFile,
        name,
        type: type.value,
      },
    });
  };
  const isDisable = file && Object.keys(file).length > 0;

  return (
    <form className={s.upl_form} onSubmit={handleSubmit(onSubmit)}>
      <ul className={s.list}>
        <li>
          <Input
            name="name"
            label={t("dealers.nameHtml")}
            control={control}
            error={errors["name"]?.message}
          />
        </li>
        <li>
          <Select
            name="type"
            type="dealers"
            label={t("dealers.typeHtml")}
            control={control}
            options={optionsType}
            // error={errors["name"]?.message}
          />
        </li>

        <li className={s.with_btn}>
          <DropZone
            getFiles={(files) => setFile(files[0])}
            setFile={setFile}
            customPlaceholder={t("dealers.htmlUpload")}
            accept={" .html,"}
            isOne
          />
        </li>

        <li
          className={clsx(s.text_drop, {
            [s.text_drop_file]: !isDisable,
          })}
        />
        <li className={s.with_btn}>
          <Button
            txtBtn={t("ui.upload_file")}
            isForm
            loading={FileUpload.loading}
            disabled={!isDisable}
          />
        </li>
      </ul>
    </form>
  );
};
export default UploadHTMLForm;
